import React from 'react';


function HottestFoods() {


    return <div
    className="wp-block-citadela-blocks-custom-container citadela-block-custom-container size-wide bg-type-none inside-space-none">
    <div className="inner-holder">
        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer negative-height">
            <div className="inner-holder" style={{marginTop: "-30px"}}></div>
        </div>


        <div className="citadela-block-responsive-text align-left">
            <h2 className="inner-tag" style={{fontSize: "14px", letterSpacing: "0.1em"}}><strong>THE HOTTEST MEALS RIGHT NOW</strong></h2>
        </div>



        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer">
            <div className="inner-holder" style={{paddingTop: "20px"}}></div>
        </div>


        <div data-block-name="woocommerce/product-tag" data-columns="4"
            data-content-visibility="{&quot;title&quot;:true,&quot;price&quot;:true,&quot;rating&quot;:false,&quot;button&quot;:false}"
            data-tags="[106]"
            className="wc-block-grid wp-block-product-tag wc-block-product-tag has-4-columns has-multiple-rows alignwide">
            <ul className="wc-block-grid__products">
                <li className="wc-block-grid__product">
                    <a href className="wc-block-grid__product-link">
                        <div className="wc-block-grid__product-image"><img fetchpriority="high" width="300" height="225"
                                src="wp-content/uploads/sites/17/2020/11/noodles-300x225.jpg"
                                className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="Maze-Men"
                                decoding="async"
                                srcSet="https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles-300x225.jpg 300w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles-768x576.jpg 768w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles-640x480.jpg 640w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles-480x360.jpg 480w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles-600x450.jpg 600w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles-150x113.jpg 150w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/noodles.jpg 800w"
                                sizes="(max-width: 300px) 100vw, 300px"/></div>
                        <div className="wc-block-grid__product-title">Maze-Men</div>
                    </a>

                    <div className="wc-block-grid__product-price price"><span className="woocommerce-Price-amount amount"><span
                                className="woocommerce-Price-currencySymbol">#</span>3,000</span></div>


                </li>
                <li className="wc-block-grid__product">
                    <a href className="wc-block-grid__product-link">
                        <div className="wc-block-grid__product-image"><img width="300" height="225"
                                src="wp-content/uploads/sites/17/2020/11/waffles-300x225.jpg"
                                className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                alt="Belgian Waffles" decoding="async"
                                srcSet="https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles-300x225.jpg 300w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles-768x576.jpg 768w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles-640x480.jpg 640w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles-480x360.jpg 480w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles-600x450.jpg 600w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles-150x113.jpg 150w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/waffles.jpg 800w"
                                sizes="(max-width: 300px) 100vw, 300px"/></div>
                        <div className="wc-block-grid__product-title">Belgian Waffles</div>
                    </a>

                    <div className="wc-block-grid__product-price price"><span className="woocommerce-Price-amount amount"><span
                                className="woocommerce-Price-currencySymbol">#</span>1,200</span></div>


                </li>
                <li className="wc-block-grid__product">
                    <a href className="wc-block-grid__product-link">
                        <div className="wc-block-grid__product-image"><img width="300" height="225"
                                src="wp-content/uploads/sites/17/2020/11/donuts-300x225.jpg"
                                className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="Doughnuts"
                                decoding="async"
                                srcSet="https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts-300x225.jpg 300w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts-768x576.jpg 768w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts-640x480.jpg 640w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts-480x360.jpg 480w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts-600x450.jpg 600w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts-150x113.jpg 150w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/donuts.jpg 800w"
                                sizes="(max-width: 300px) 100vw, 300px"/></div>
                        <div className="wc-block-grid__product-title">Doughnuts</div>
                    </a>

                    <div className="wc-block-grid__product-price price"><span className="woocommerce-Price-amount amount"><span
                                className="woocommerce-Price-currencySymbol">#</span>4,000</span></div>


                </li>
                <li className="wc-block-grid__product">
                    <a href className="wc-block-grid__product-link">
                        <div className="wc-block-grid__product-image"><img loading="lazy" width="300" height="225"
                                src="wp-content/uploads/sites/17/2020/11/soup-hokkaido-300x225.jpg"
                                className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="Hokkaido"
                                decoding="async"
                                srcSet="https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido-300x225.jpg 300w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido-768x576.jpg 768w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido-640x480.jpg 640w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido-480x360.jpg 480w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido-600x450.jpg 600w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido-150x113.jpg 150w, https://preview.ait-themes.club/citadela/fooddelivery/wp-content/uploads/sites/17/2020/11/soup-hokkaido.jpg 800w"
                                sizes="(max-width: 300px) 100vw, 300px"/></div>
                        <div className="wc-block-grid__product-title">Hokkaido</div>
                    </a>

                    <div className="wc-block-grid__product-price price"><span className="woocommerce-Price-amount amount"><span
                                className="woocommerce-Price-currencySymbol">#</span>2,500</span></div>


                </li>
            </ul>
        </div>


        <div className="wp-block-citadela-blocks-spacer citadela-block-spacer responsive-options"
            data-block-attr="{&quot;desktop&quot;:{&quot;height&quot;:&quot;20px&quot;},&quot;mobile&quot;:{&quot;height&quot;:&quot;-15px&quot;,&quot;negative&quot;:true}}"
            data-block-mobile-breakpoint="782">
            <div className="inner-holder" style={{paddingTop: "20px"}}></div>
        </div>



        <hr className="wp-block-separator has-text-color has-css-opacity has-background is-style-wide"
            style={{backgroundColor: "#e8e8e8", color:"#e8e8e8"}}/>
    </div>
</div>
}


export default HottestFoods